import { flow } from "fp-ts/lib/function";

import { Scale } from "../../lens-stats/formatters";
import { roundWithScale, safeDivide } from "../math";
import { type InsightsMetrics, type LensCTRPair, type StatsItem } from "../models";

export const mapCTRValueOverTime =
    (lensCTRPair: LensCTRPair) =>
    (computedMetric: InsightsMetrics<StatsItem>): InsightsMetrics<StatsItem> => {
        const valueOverTime = flow(
            ({ swipeUps, lensPlays }: LensCTRPair) => safeDivide(swipeUps, lensPlays) * 100,
            roundWithScale(Scale.h),
        )(lensCTRPair);

        return {
            ...computedMetric,
            valueOverTime,
        };
    };

export const mapCTRValueOverTimeFormatted = (
    computedMetric: InsightsMetrics<StatsItem>,
): InsightsMetrics<StatsItem> => ({
    ...computedMetric,
    valueOverTimeFormatted:
        computedMetric.valueOverTime && computedMetric.valueOverTime > 0
            ? computedMetric.valueOverTime.toFixed(1) + "%"
            : "-",
});
